// eslint-disable-next-line import/no-cycle
import * as loginApi from '@/api/login'
import { getToken, removeToken, setTenantId, setToken } from '@/utils/auth'
import * as Sentry from '@sentry/vue'
import { authUtils } from 'blm-utils'

const user = {
  state: {
    token: getToken() || localStorage.TOKEN || null,
    userInfo: {},
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      localStorage.TOKEN = token
      state.token = token
    },
    SET_USER_INFO: (state, userInfo = {}) => {
      // localStorage.USERINFO = JSON.stringify(userInfo)
      state.userInfo = userInfo
      const tenantId = userInfo.tenantId || 1
      // 清理租牌相关 localStorage
      authUtils.clearHireSessionInfo()
      setTenantId(tenantId)
      Sentry.configureScope((scope) => {
        // 上报用户信息
        scope.setUser({ id: userInfo?.id })
      })
    },
  },
  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password.trim()
      const captcha = userInfo.captcha.trim()
      return new Promise((resolve, reject) => {
        loginApi.login(username, password, captcha).then((response) => {
          const { data } = response
          const userVO = data.userVO || {}
          commit('SET_USER_INFO', userVO)
          commit('SET_TOKEN', data.token)
          setToken({ token: data.token, expiration: data.expiration })
          resolve()
        }).catch((error) => {
          // 清理租牌相关 localStorage
          authUtils.clearHireSessionInfo()
          reject(error)
        })
      })
    },
    SetUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        loginApi.getInfoByToken().then((response) => {
          const { data } = response
          const userInfo = data.userVO || {}
          userInfo.bindings = data.bindings || []
          commit('SET_USER_INFO', userInfo)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    RefreshToken() {
      return new Promise((resolve, reject) => {
        loginApi.refreshToken().then((response) => {
          const { data } = response
          setToken({ token: data.token, expiration: data.expiration })
          resolve()
        }).catch((error) => {
          this.$message.error(error.msg)
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit }) {
      // 维保退出登陆
      loginApi.purchaseMallLogOut()
      return new Promise((resolve, reject) => {
        loginApi.logout().then(() => {
          commit('SET_USER_INFO', {})
          removeToken()
          localStorage.userInfo = ''
          resolve()
        }).catch((error) => {
          this.$message.error(error.msg)
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_USER_INFO', {})
        removeToken()
        localStorage.userInfo = ''
        resolve()
      })
    },
    async UnbindWechat({ dispatch }) {
      await loginApi.unbindWechat()
      await dispatch('GetUserInfo')
    },
  },
}

export default user
